import React, { useState } from 'react'
import { Box } from '@mui/material'
import Sidebar from './Sidebar'
import Header from './Header'

export default function DashboardLayout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  
  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed)
  }
  
  return (
        <Box sx={{ 
          minHeight: '100vh', 
          background: 'linear-gradient(135deg, #F0F4FF 0%, #E8F5F0 50%, #FFF8E8 100%)',
        }}>
      <Sidebar 
        sidebarCollapsed={sidebarCollapsed} 
        toggleSidebar={toggleSidebar}
      />
      <Header sidebarCollapsed={sidebarCollapsed} />
      
      {/* Main content area */}
      <Box
        sx={{
          marginLeft: sidebarCollapsed ? '70px' : '280px',
          marginTop: '70px',
          transition: 'margin-left 0.2s',
          padding: 3,
        }}
      >
        <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
          {children}
        </Box>
      </Box>
    </Box>
  )
}
